import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class DashboardDefaultGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<UrlTree> {
    return this.authenticationService.getPlanFeaturesEnabled().pipe(
      map(plan => {
        const availableSkins = Array.isArray(plan?.available_dashboard_skins)
          ? plan.available_dashboard_skins : [];
        const skinPaths: Record<string, string> = {
          logistics: '/dashboard/logistics',
          tax_accountancy: '/dashboard/tax-accountancy',
          financial_services: '/dashboard/financial-services',
        };
        const selectedPath = availableSkins.includes(plan?.default_skin)
          ? skinPaths[plan.default_skin] : undefined;
        return this.router.createUrlTree(
          [selectedPath || '/dashboard'],
          { queryParams: route.queryParams }
        );
      }),
      catchError(() => of(this.router.createUrlTree(['/dashboard'], { queryParams: route.queryParams })))
    );
  }
}
